import { useCallback, useEffect, useState } from 'react';
import { api, formatTl } from '../lib/api';

/**
 * FATURALANDIR ÇEKMECESİ — siparişin teklifinden Paraşüt'e satış faturası.
 * Sipariş Hattı (pano / liste) ve Sipariş Detayı aynı bileşeni açar.
 * Önce önizleme gelir (ne gidecek, eksik ne); onayla Paraşüt'te fatura KAYDI açılır.
 */
/**
 * Bağlı olmayan satır için iki yol: Paraşüt'te ürünü OLUŞTUR ya da mevcut
 * Paraşüt ürününü ARAYIP bağla. Arama yazdıkça yapılır; katalog listelenmez.
 */
function ParasutBagla({ productId, ad, bitti, hata }: { productId: number; ad: string; bitti: () => void; hata: (m: string | null) => void }) {
  const [kip, setKip] = useState<'kapali' | 'ara'>('kapali');
  const [q, setQ] = useState(ad);
  const [sonuc, setSonuc] = useState<{ parasutId: string; ad: string; kod: string | null; birim: string | null; bagliKod: string | null }[] | null>(null);
  const [araniyor, setAraniyor] = useState(false);
  const [katalog, setKatalog] = useState<{ adet: number; iniyor: boolean } | null>(null);
  const [yakin, setYakin] = useState(false);
  const [mesgul, setMesgul] = useState(false);
  useEffect(() => {
    if (kip !== 'ara' || q.trim().length < 2) { setSonuc(null); return; }
    let iptal = false;
    setAraniyor(true);
    const t = setTimeout(() => {
      api<{ urunler: NonNullable<typeof sonuc>; katalogAdet: number; katalogIniyor: boolean; yakin?: boolean }>(`/api/parasut/urun-ara?q=${encodeURIComponent(q.trim())}`)
        .then((r) => { if (!iptal) { setSonuc(r.urunler); setYakin(!!r.yakin); setKatalog({ adet: r.katalogAdet, iniyor: r.katalogIniyor }); } })
        .catch((e) => { if (!iptal) { setSonuc([]); hata(e instanceof Error ? e.message : 'Arama yapılamadı'); } })
        .finally(() => { if (!iptal) setAraniyor(false); });
    }, 350);
    return () => { iptal = true; clearTimeout(t); };
  }, [kip, q]);   // eslint-disable-line react-hooks/exhaustive-deps

  async function olustur() {
    if (!window.confirm(`"${ad}" Paraşüt'te yeni ürün kartı olarak açılsın mı?`)) return;
    setMesgul(true); hata(null);
    try { await api('/api/parasut/urun-olustur', { method: 'POST', body: JSON.stringify({ productId }) }); bitti(); }
    catch (e) { hata(e instanceof Error ? e.message : 'Paraşüt ürünü açılamadı'); }
    finally { setMesgul(false); }
  }
  async function bagla(parasutUrunId: string, urunAd: string) {
    setMesgul(true); hata(null);
    try { await api('/api/parasut/urun-bagla', { method: 'POST', body: JSON.stringify({ productId, parasutUrunId, ad: urunAd }) }); bitti(); }
    catch (e) { hata(e instanceof Error ? e.message : 'Bağlanamadı'); }
    finally { setMesgul(false); }
  }

  if (kip === 'kapali') {
    return (
      <div className="ccd-row" style={{ gap: 6, flexWrap: 'wrap' }}>
        <button type="button" className="ccd-btn ccd-btn-sm" disabled={mesgul} onClick={() => void olustur()}
                title="Bu ürünü Paraşüt'te yeni ürün kartı olarak açar ve bağlar">{mesgul ? '…' : '＋ Oluştur'}</button>
        <button type="button" className="ccd-btn ccd-btn-sm" disabled={mesgul} onClick={() => setKip('ara')}
                title="Paraşüt'te zaten varsa arayıp bağlayın">🔗 Bağla</button>
      </div>
    );
  }
  return (
    <div style={{ position: 'relative', minWidth: 230 }}>
      <input className="ccd-input" autoFocus value={q} placeholder="Paraşüt'te ara: ad ya da kod…" onChange={(e) => setQ(e.target.value)}
             onKeyDown={(e) => { if (e.key === 'Escape') setKip('kapali'); }} />
      <div className="ccd-oneri" style={{ position: 'static', marginTop: 4, maxHeight: 220 }}>
        {araniyor ? <div className="ccd-oneri-bos"><span className="ccd-oneri-donen" /> Paraşüt'te aranıyor…</div>
          : q.trim().length < 2 ? <div className="ccd-oneri-bos">En az 2 harf yazın</div>
          : !sonuc || sonuc.length === 0 ? <div className="ccd-oneri-bos">{katalog && katalog.adet === 0
              ? 'Paraşüt ürün listesi panele ilk kez indiriliyor (yaklaşık 10 dakika). Şimdilik ürünün Paraşüt\'teki TAM adını yazın ya da ＋ Oluştur\'u kullanın.'
              : 'Eşleşen Paraşüt ürünü yok — kelimeyi kısaltın ya da ＋ Oluştur\'u kullanın'}</div>
          : <>{yakin && <div className="ccd-oneri-bos" style={{ textAlign: 'left' }}>Bu adla birebir ürün yok. En yakın olanlar aşağıda; hiçbiri değilse “＋ Yeni ürün olarak oluştur”a basın.</div>}
          {sonuc.map((u) => (
            <button key={u.parasutId} type="button" className="ccd-oneri-satir" disabled={mesgul || !!u.bagliKod}
                    title={u.bagliKod ? `Zaten ${u.bagliKod} koduna bağlı` : 'Bu Paraşüt ürününe bağla'} onClick={() => void bagla(u.parasutId, u.ad)}>
              <span className="ccd-oneri-ad">{u.ad}</span>
              <span className="ccd-muted">{u.bagliKod ? `→ ${u.bagliKod}` : (u.birim ?? '')}</span>
            </button>
          ))}</>}
      </div>
      <div className="ccd-row" style={{ gap: 6, marginTop: 4, flexWrap: 'wrap' }}>
        <button type="button" className="ccd-btn ccd-btn-sm" disabled={mesgul} onClick={() => void olustur()}
                title="Aradığınız ürün listede yoksa: bu ürünü muhasebe programında yeni ürün kartı olarak açar ve bağlar">{mesgul ? '…' : '＋ Yeni ürün olarak oluştur'}</button>
        <button type="button" className="ccd-btn ccd-btn-ghost ccd-btn-sm" onClick={() => setKip('kapali')}>Vazgeç</button>
      </div>
    </div>
  );
}

type FaturaOnizleme = {
  siparis: string; teklif: string; cari: string; engeller: string[]; kip: string;
  araToplamKurus: number; kdvKurus: number; genelToplamKurus: number;
  satirlar: { productId: number | null; kod: string; ad: string; parasutUrun: string | null; miktar: number; birimFiyatTl: number; iskontoPct: number; netKurus: number }[];
};

export default function FaturaCekmece({ siparisId, kapat, kesildi }: {
  siparisId: number; kapat: () => void;
  /** Fatura açılınca çağrılır (liste / detay yenilensin). Çekmece açık kalır, sonucu gösterir. */
  kesildi: () => void;
}) {
  const [fatura, setFatura] = useState<{ v: FaturaOnizleme | null; hata: string | null; bekliyor: boolean; bitti: string | null }>(
    { v: null, hata: null, bekliyor: true, bitti: null });

  const onizle = useCallback(async () => {
    setFatura({ v: null, hata: null, bekliyor: true, bitti: null });
    try {
      const v = await api<FaturaOnizleme>(`/api/siparis/${siparisId}/faturalandir`, { method: 'POST' });
      setFatura({ v, hata: null, bekliyor: false, bitti: null });
    } catch (e) { setFatura({ v: null, hata: e instanceof Error ? e.message : 'Önizleme alınamadı', bekliyor: false, bitti: null }); }
  }, [siparisId]);
  useEffect(() => { void onizle(); }, [onizle]);

  async function faturaKes() {
    if (!fatura.v) return;
    setFatura({ ...fatura, bekliyor: true, hata: null });
    try {
      await api(`/api/siparis/${siparisId}/faturalandir?uygula=1`, { method: 'POST' });
      setFatura({ ...fatura, bekliyor: false, bitti: 'Fatura kaydı açıldı. Resmî belge (e-Fatura / e-Arşiv) için sipariş detayındaki "Resmîleştir" adımını kullanın; fatura birkaç dakika içinde panele de düşer.' });
      kesildi();
    } catch (e) { setFatura({ ...fatura, bekliyor: false, hata: e instanceof Error ? e.message : 'Fatura kesilemedi' }); }
  }

  return (
    <div className="ccd-drawer-arka" onClick={() => !fatura.bekliyor && kapat()} role="presentation">
      <aside className="ccd-drawer" style={{ width: 'min(900px, 100%)' }} onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true" aria-label="Faturalandır">
        <div className="ccd-stack">
          <div className="ccd-row-between">
            <div><div className="ccd-eyebrow">Sipariş → Fatura</div><h2 className="ccd-heading">Faturalandır</h2></div>
            <button className="ccd-btn ccd-btn-ghost ccd-btn-sm" onClick={() => kapat()} disabled={fatura.bekliyor}>Kapat</button>
          </div>
          {fatura.hata && <div className="ccd-banner ccd-banner-danger"><span className="ccd-banner-icon">!</span><span>{fatura.hata}</span></div>}
          {fatura.bitti && <div className="ccd-banner"><span className="ccd-banner-icon">✓</span><span>{fatura.bitti}</span></div>}
          {!fatura.v ? (fatura.bekliyor && <div className="ccd-inline-note">Hazırlanıyor…</div>) : (
            <>
              <div className="ccd-meta">
                <b>{fatura.v.cari}</b> · {fatura.v.siparis} · {fatura.v.teklif}
                {fatura.v.kip !== 'real' && <span className="ccd-badge" style={{ marginLeft: 8 }}>deneme kipi — gerçek Paraşüt'e gitmez</span>}
              </div>
              {fatura.v.engeller.length > 0 && (
                <div className="ccd-banner ccd-banner-danger">
                  <span className="ccd-banner-icon">!</span>
                  <div><b>Fatura henüz kesilemez.</b> Aşağıda kırmızı satırları tamamlayın:
                    <b> ＋ Oluştur</b> ürünü Paraşüt'te açar, <b>🔗 Bağla</b> Paraşüt'teki mevcut ürünü seçtirir.
                    {fatura.v.engeller.filter((e) => !e.includes('Paraşüt ürününe bağlı değil')).map((e, n) => <div key={n}>• {e}</div>)}
                  </div>
                </div>
              )}
              <div className="ccd-table-wrap">
                <table className="ccd-table">
                  <thead><tr>
                    <th className="ccd-th">Ürün</th><th className="ccd-th">Paraşüt'teki karşılığı</th>
                    <th className="ccd-th ccd-td-num">Miktar</th><th className="ccd-th ccd-td-num">Birim ₺</th>
                    <th className="ccd-th ccd-td-num">İsk. %</th><th className="ccd-th ccd-td-num">Tutar</th>
                  </tr></thead>
                  <tbody>
                    {fatura.v.satirlar.map((s, n) => (
                      <tr key={n} className="ccd-tr">
                        <td className="ccd-td"><span className="ccd-mono">{s.kod}</span><div className="ccd-meta">{s.ad}</div></td>
                        <td className="ccd-td">
                          {s.parasutUrun ? (
                            <span>
                              {s.parasutUrun}{' '}
                              {s.productId != null && !fatura.bitti && (
                                <button type="button" className="ccd-btn ccd-btn-ghost ccd-btn-sm" title="Yanlış ürüne bağlandıysa bağı kaldırıp yeniden seçin"
                                        onClick={async () => {
                                          if (!window.confirm(`"${s.parasutUrun}" bağı kaldırılsın mı? Sonra yeniden bağlayabilir ya da Paraşüt'te oluşturabilirsiniz.`)) return;
                                          try { await api('/api/parasut/urun-bag-kaldir', { method: 'POST', body: JSON.stringify({ productId: s.productId }) }); void onizle(); }
                                          catch (e) { setFatura((f) => ({ ...f, hata: e instanceof Error ? e.message : 'Bağ kaldırılamadı' })); }
                                        }}>Değiştir</button>
                              )}
                            </span>
                          ) : (s.productId == null ? <span className="ccd-kpi-down">ürün kartı yok</span> : (
                            <ParasutBagla productId={s.productId} ad={s.ad} bitti={() => void onizle()} hata={(m) => setFatura((f) => ({ ...f, hata: m }))} />
                          ))}
                        </td>
                        <td className="ccd-td ccd-td-num">{s.miktar}</td>
                        <td className="ccd-td ccd-td-num">{formatTl(Math.round(s.birimFiyatTl * 100))}</td>
                        <td className="ccd-td ccd-td-num">%{s.iskontoPct}</td>
                        <td className="ccd-td ccd-td-num"><b>{formatTl(s.netKurus)}</b></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="ccd-meta">
                Ara toplam {formatTl(fatura.v.araToplamKurus)} · KDV {formatTl(fatura.v.kdvKurus)} · <b>Genel toplam {formatTl(fatura.v.genelToplamKurus)}</b>
              </div>
              <div className="ccd-meta">
                Paraşüt'te fatura <b>kaydı</b> açılır; e-Fatura / e-Arşiv numarası bu adımda alınmaz, sipariş detayındaki <b>Resmîleştir</b> adımıyla panelden alınır.
                Miktarın birimi Paraşüt'teki ürünün birimiyle aynı olmalı (kutu / m²) — "Paraşüt'teki karşılığı" sütununu kontrol edin.
              </div>
              {!fatura.bitti && (
                <button className="ccd-btn ccd-btn-primary" disabled={fatura.bekliyor || fatura.v.engeller.length > 0}
                        onClick={() => { if (window.confirm(`${fatura.v!.cari} adına ${formatTl(fatura.v!.genelToplamKurus)} tutarında fatura Paraşüt'te açılsın mı?`)) void faturaKes(); }}>
                  {fatura.bekliyor ? 'Paraşüt\'e gönderiliyor…' : 'Paraşüt\'te faturayı aç'}
                </button>
              )}
            </>
          )}
        </div>
      </aside>
    </div>
  );
}
